import React from 'react';

import {
  DndContext,
  useSensors,
  useSensor,
  PointerSensor,
  KeyboardSensor,
  type DragEndEvent,
  type DragStartEvent,
  type UniqueIdentifier,
} from '@dnd-kit/core';
import {
  SortableContext,
  sortableKeyboardCoordinates,
} from '@dnd-kit/sortable';

type SortableProductListProps = {
  children: React.ReactNode;
  onDragEnd: (event: DragEndEvent) => void;
  items: UniqueIdentifier[];
  useNonZeroBasedIndices?: boolean;
  onDragStart?: (event: DragStartEvent) => void;
};

function SortableItemsContainer({
  children,
  onDragEnd,
  items,
  useNonZeroBasedIndices = false,
  onDragStart,
}: SortableProductListProps) {
  const sensors = useSensors(
    useSensor(PointerSensor),
    useSensor(KeyboardSensor, { coordinateGetter: sortableKeyboardCoordinates })
  );

  const sortableItems = useNonZeroBasedIndices
    ? items.map((_, index) => index + 1)
    : items;

  return (
    <DndContext
      sensors={sensors}
      onDragEnd={onDragEnd}
      onDragStart={onDragStart}
    >
      <SortableContext items={sortableItems}>{children}</SortableContext>
    </DndContext>
  );
}

export { SortableItemsContainer };
